export const SET_MODAL = 'SET_MODAL'
export const REMOVE_MODAL_BY_ID = 'REMOVE_MODAL_BY_ID'

// reducer
export const MODAL_STATE_KEY = 'MODAL'

export const DIALOG_CANCEL = 'DIALOG_CANCEL'
